import ApiService from "@/services/ApiService";
import moment from "moment";
import sortBy from "lodash/sortBy";

/**
 * @typedef {Object} Alarm
 * @property {string} camId Camera id: cam1id
 * @property {string} name Camera name: Cam 1
 * @property {number} timestamp Event unix timestamp
 * @property {string} comment Event comment
 * @property {string} id Event id
 * @property {string} time_write Event time write in base
 * @property {string} time Event timestamp DD-MM-YY HH:mm:ss
 * @property {"ATTACH"|"BLINDING"|"DETACH"|"DEFOCUSED"|"FOCUSED"|"MD_START"|"MD_STOP"|"REC"|"REC_STOP"|"UNBLINDING"|"ARMED"|"DISARMED"|"REC_ERROR"} action Event action
 */

/**
 * @typedef {Object} Params
 * @property {string} startTime  Date start time 2023-06-21T16:43:27+03:00
 * @property {string} stopTime Date start time 2023-06-21T16:43:27+03:00
 * @property {number} max_count Maximum number of Events
 */

class AlarmApi {
  constructor() {
    /** @private */
    this.http = new ApiService();
  }

  /**
   * @param {Array<{id: string}>} cams Current active cams
   * @param {Params} params Params for request
   * @return {Promise<Alarm[]>} Array with alarms ordered by newer to older
   *
   */
  async getAlarms(cams, params = {}) {
    const requestDateFormat = "YYYYMMDDTHHmmss";

    const transformedCams = cams.reduce((result, currentCam) => {
      result[currentCam.id] = currentCam;

      return result;
    }, {});

    const paramsCopy = {
      ...params
    };

    paramsCopy.startTime = moment(paramsCopy.startTime).format(
      requestDateFormat
    );
    paramsCopy.stopTime = moment(paramsCopy.stopTime).format(requestDateFormat);

    const response = await this.http.get(`protocol/?`, {
      params: {
        ids: Object.keys(transformedCams).toString(),
        type: "CAM",
        order: "desc",
        ...paramsCopy
      }
    });

    const result = response.map(event => ({
      camId: event.obj_id,
      name: transformedCams[event.obj_id]
        ? transformedCams[event.obj_id].name
        : "Not Found",
      timestamp: moment(event.time, "DD-MM-YY HH:mm:ss").unix(),
      ...event
    }));

    return sortBy(result, alarm => -alarm.timestamp);
  }
}

export const alarmApiService = new AlarmApi();



// WEBPACK FOOTER //
// ./src/api/alarm/alarm.api.js